import { HttpProviderOptions } from "web3-core-helpers";
import Web3 from "web3/dist/web3.min.js";
import {
  AVALANCHE_CHAIN_ID,
  AVALANCHE_RPC,
  BSC_RPC_ENDPOINTS,
  BSC_TESTNET_CHAIN_ID,
  BSC_TESTNET_ENDPOINTS,
  FANTOM_CHAIN_ID,
  FANTOM_RPC,
  KOVAN_CHAIN_ID,
  KOVAN_RPC,
} from "./constants";

export const getClient = (chainId: number, library?: Object) => {
  switch (chainId) {
    case FANTOM_CHAIN_ID: {
      const provider = new Web3.providers.HttpProvider(
        FANTOM_RPC as string,
        { timeout: 10000 } as HttpProviderOptions
      );
      return new Web3(library || provider);
    }
    case KOVAN_CHAIN_ID: {
      const provider = new Web3.providers.HttpProvider(
        KOVAN_RPC as string,
        { timeout: 10000 } as HttpProviderOptions
      );
      return new Web3(library || provider);
    }
    case AVALANCHE_CHAIN_ID: {
      const provider = new Web3.providers.HttpProvider(
        AVALANCHE_RPC as string,
        { timeout: 10000 } as HttpProviderOptions
      );
      return new Web3(library || provider);
    }
    case BSC_TESTNET_CHAIN_ID: {
      const provider = new Web3.providers.HttpProvider(
        BSC_TESTNET_ENDPOINTS as string,
        { timeout: 10000 } as HttpProviderOptions
      );
      return new Web3(library || provider);
    }
    default: {
      const provider = new Web3.providers.HttpProvider(
        BSC_RPC_ENDPOINTS[
          ~~(BSC_RPC_ENDPOINTS.length * Math.random())
        ] as string,
        { timeout: 10000 } as HttpProviderOptions
      );
      return new Web3(library || provider);
    }
  }
};

export const web3Instance = {
  _instance: null,
  getInstance: (chainId = 56, library?: Object) => {
    if (!web3Instance._instance) {
      web3Instance._instance = getClient(chainId, library);
    }

    return web3Instance._instance;
  },
};

export const web3ReadOnlyInstance = {
  _instance: null,
  getInstance: (chainId = 56, library?: Object) => {
    if (!web3ReadOnlyInstance._instance) {
      web3ReadOnlyInstance._instance = getClient(chainId, library);
    }

    return web3ReadOnlyInstance._instance;
  },
};
